const locale = {
  placeholder: 'ÐÐ±ÐµÑÑÑÑ ÑÐ°Ñ',
};

export default locale;
